export default "__VITE_ASSET__DpMk614w__"